<template>
  <div>
    <div class="pact-mail-line"></div>
    <div class="mail-title">发送至邮箱</div>
    <van-field class="mail-input" clearable v-model="mail" placeholder="请输入邮箱" />
    <van-button class="mail-button" :loading="loading"  @click="sendMail" loading-text="提交中..." round block type="info" native-type="submit">
      提交
    </van-button>
  </div>
</template>

<script>
import Vue from 'vue';
import { Toast, Button, Field } from 'vant';
import { sendEContract } from '../../api/pact';

Vue.use(Toast).use(Button).use(Field);

export default {
  data() {
    return {
      loading: false,
      mail: '',
      recordId: '',
    };
  },
  mounted() {
    const {query} = this.$route;
    this.mail = query.mail;
    this.recordId = query.recordId;
  },
  methods: {
    sendMail() {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 3000);
      if (!this.mail) {
        this.loading = false;
        return Toast.fail('邮箱不能为空');
      }
      if ((!this.mail.includes('@') || !this.mail.includes('.')) || escape(this.mail).indexOf('%u') > 0) {
        this.loading = false;
        return Toast.fail('邮箱格式错误\n请重新填写');
      } else {
        sendEContract({
          recordIds: [this.recordId],
          isReSend: 2,
          email: this.mail,
        }).then(res => {
          this.loading = false;
          Toast.success('发送成功');
          this.$router.push({
            path: '/pact/detail',
          });
        }).catch(err => {
          this.loading = false;
          return Toast.fail(err.message);
        });
      }
    },
  },
};
</script>

<style lang="scss">
.mail-title {
  padding: 32px 0 20px 32px;
  font-size: 32px;
}
.pact-mail-line {
  height: 15px;
  background: #ededed;
}
.mail-button {
  margin: 60px 0 0 32px;
  width: calc(100% - 64px);
}
</style>
